import buildAlgoliaAnalyticsParams from './buildAlgoliaAnalyticsParams';

// Ambient page context for the Algolia search client (CON-8651).
//
// The search client is a plain module called from dozens of places — every
// InstantSearch widget plus a handful of direct `searchClient.search()` calls
// — so the page it is searching from cannot reach it as a prop. It reaches it
// as module state instead, written by the sync components in the consumer app.
//
// **Writes are browser-only, and that is load-bearing.** Node serves concurrent
// requests from one process and interleaves them at every await, so a value
// written during one request's SSR can be read by another's. Mis-slicing a
// report would be survivable; `ruleContexts` changing which results Algolia
// returns for the wrong visitor is not. Server-rendered searches therefore get
// their parameters passed explicitly as `<Configure>` props instead, and this
// store stays empty there.

const isBrowser = () => typeof window !== 'undefined';

let context = null;

export const setAlgoliaAnalyticsContext = partial => {
  if (!isBrowser() || !partial) {
    return;
  }

  context = { ...context, ...partial };
};

export const getAlgoliaAnalyticsParams = () => {
  if (!isBrowser() || !context) {
    return null;
  }

  return buildAlgoliaAnalyticsParams(context);
};

// Test seam — the module state outlives a single test otherwise.
export const resetAlgoliaAnalyticsContext = () => {
  context = null;
};
